import React, { useState,useEffect  } from 'react';
import "./Sidebarperson.css";
const Sidebarperson = ({data,extended}) => {

    let [name, status, email] = data.split(":");
    let [lasname, vorname] = name.split(" ");
    let co = "green";
    if (status == "abwesend"){
       co ="yellow";
    }
    if (status == "offline"){
      return (<></>);
    }
    if (extended == ""){

    }
    let s = "none";
    if (extended != "3%"){
      s = "block";
    }
    return (
       <div className='onlinebar-person-div'>
          <div title={name} className='onlinebar-cicle-div'>
              {lasname.charAt(0).toUpperCase()}{vorname.charAt(0).toUpperCase()}
          </div>
          <div title={status} style={{backgroundColor : co}} className="onlinebar-person-online">
          </div>
       </div>
    );



}
export default Sidebarperson;